import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import { createApp } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import * as components from '@/components/index';
import UiCountUp from '@/components/ui/count-up.vue';
import UiDropdown from '@/components/ui/dropdown.vue';
import UiIcon from '@/components/ui/icon.vue';
import UiIntersect from '@/components/ui/intersect.vue';
import UiModal from '@/components/ui/modal.vue';
import UiMap from '@/components/ui/map.vue';
import useModal from '@/composables/modal';
import useNavigation from '@/composables/navigation';
const App = createApp({
    components: {
        ...components,
    },
    setup() {
        const { setModal, modalName } = useModal();
        const { isMenuOpen, toggleMenu } = useNavigation();
        return {
            isMenuOpen,
            modalName,
            setModal,
            toggleMenu,
            swiperModules: [Pagination],
        };
    },
});
// Global components
App.component('Swiper', Swiper);
App.component('SwiperSlide', SwiperSlide);
App.component('UiCountUp', UiCountUp);
App.component('UiDropdown', UiDropdown);
App.component('UiIcon', UiIcon);
App.component('UiIntersect', UiIntersect);
App.component('UiModal', UiModal);
App.component('UiMap', UiMap);
App.mount('#app');
